import React, { useEffect, useState } from "react";
import { TablePagination, Button, TableRow, Table, TableHead, TableBody, Typography, TableCell, Card, Box, Grid } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import ActivityService from "./Locality/Service/activityService";
import StudentService from "./Locality/Service/studentService";
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import UserProfileCard from "./UserProfileCard";
import StudentCards from "./UserProfileCard";
import SuperActivityService from "./Locality/Service/superActivityService"

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
}));

export default function ParentActivity() {

  const [studentsList, setstudentsList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [activeTab, setActiveTab] = useState('');
  const [addSuperActivityList, setAddSuperActivityList] = useState([]);
  var [isLoading, setIsLoading] = useState(false);
const [selectedStudent, setSelectedStudent] = useState(null);
  const [activity, setActivity] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    fetchStudentList();
  
     return () => {
          
         setActivityList([]);
        }
  }, []);
useEffect(() => {
  if (selectedStudent?.classId) {
    getSuperActivityList();
  }
}, [selectedStudent]);

  const colorMap = {
    "P": "#17875f",
    "WI": "#FF9800",
    "WA": "#FFD700",
  };


const handleStudentClick = (studentId, classId) => {
  setSelectedStudent({ studentId, classId }); // <-- Store selection
  getActivityList(null, null, studentId, classId);

  const selected = studentList.find(s => s._id === studentId);
  if (selected) {
    setstudentsList([selected]);
  }
};

  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const handleClose = () => {
    setOpen(false);
  };
 
const onSubmit = (superActivityId) => {
  if (!selectedStudent) return;

  setIsLoading(true);
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));

  const keys = {
    schooleId: userDetails.schooleId,
    isFuturePlanning: false,
    isInitLoad: true,
    superActivityId: superActivityId,
    studentId: selectedStudent.studentId,
    classId: selectedStudent.classId,
    startDate: "",
    endDate: "",
    status: true
  };

  ActivityService.findActivityReports(keys)
    .then((result) => {
      setActivityList(result);

      const allStudents = [];
      result.forEach(activity =>
        activity.activityList.forEach(rec => {
          const student = rec.studentId;
          if (student && !allStudents.find(s => s._id === student._id)) {
            allStudents.push(student);
          }
        })
      );
      setstudentsList(allStudents);
    })
    .catch((err) => console.error(err))
    .finally(() => setIsLoading(false));
};

  const fetchStudentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    StudentService.findStudentList({ userId: userDetails._id })
      .then((res) => {
        const mappedStudents = res.map((student) => ({
          ...student,
          fullName: `${student.firstName} ${student.lastName}`,
        }));
        // setStudentList(mappedStudents);
        setStudentList(mappedStudents);
        setstudentsList([mappedStudents[0]]);
      if (mappedStudents.length > 0) {
  const defaultStudent = mappedStudents[0];
  setSelectedStudent({
    studentId: defaultStudent._id,
    classId: defaultStudent.classId._id
  });
  getActivityList(defaultStudent._id, defaultStudent.classId._id);
  getSuperActivityList(defaultStudent.classId._id);
}


      })
      .catch((err) => console.error(err));
  };

const getSuperActivityList = async () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  if (!selectedStudent?.classId) {
    console.warn("No classId available for super activity fetch.");
    return;
  }

  try {
    const res = await SuperActivityService.getAllSuperActivityById(
      userDetails.schooleId,
      { classId: selectedStudent?.classId } // ✅ Make sure this is present
    );

    setAddSuperActivityList(res);

    if (res.length > 0) {
      setActiveTab(res[0]._id);
      onSubmit(res[0]._id);
    }
  } catch (err) {
    console.error(err);
  }
};


  const handleTabClick = (superActivityId) => {
    setActiveTab(superActivityId);
    onSubmit(superActivityId);
  };

  const getActivityList = (event, obj, studentId, classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    ActivityService.findActivityList({ studentId, classId }).then((res) => {
      
      const formattedActivity = res.map((activity) => ({
        ...activity,
        activityStudentDetailsListId: activity.activityStudentDetailsListId.length ? activity.activityStudentDetailsListId[0] : {},
        date: activity.date ? formatDate(activity.date) : "",
      }));
      setActivityList(formattedActivity);

    }).catch((err) => {
      // setError(err.message);
    });
  }
  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year.slice(2)}`;
  };

  return (
    <>
      <PageTitle title="Student Activity" />

      <>
        <Card sx={{ maxWidth: 345 }}>
          {studentList.length > 1 && (<Box style={{ margin: 15 }}>
            <StudentCards studentList={studentList} onStudentSelect={handleStudentClick} />

          </Box>)}
        </Card>
   <br></br>
        <div className="overflow-x-auto activity-record p-4 space-y-6">
          <div>
            <h2 className="text-xl font-bold mb-2 text-gray-700">Area Of Work</h2>

          </div>
          <br></br>
      <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
  <div style={{ display: 'inline-flex', gap: '10px', paddingBottom: '10px' }}>
    {addSuperActivityList.map((area) => {
      const isActive = activeTab === area._id;
      return (
        <button
          key={area._id}
          onClick={() => handleTabClick(area._id)}
          style={{
            padding: '10px 16px',
            borderBottom: isActive ? '3px solid rgb(15 59 98)' : '3px solid transparent',
            backgroundColor: isActive ? '#DBEAFE' : 'transparent',
            color: isActive ? 'rgb(15 59 98)' : '#4B5563',
            fontWeight: '600',
            borderRadius: '6px 6px 0 0',
            whiteSpace: 'nowrap',
            cursor: 'pointer'
          }}
        >
          {area.superActivityName}
        </button>
      );
    })}
  </div>
</div>


<br></br>
{isLoading && (
  <div className="text-center p-4 text-blue-600">Loading data...</div>
)}
          <div style={{ overflowX: "auto" }}>
            <table border="1" cellPadding="8" style={{ borderCollapse: "collapse", minWidth: "800px", width: "max-content" }}>
              <thead>
                <tr>
                  <th>Activity</th>
                  {studentsList.map(student => (
                    <th key={student._id}>
                      {student.firstName?.toUpperCase()} {student.lastName?.toUpperCase()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {activityList.map(activity => (
                  <tr key={activity.id}>
                    <td
                      style={{
                        backgroundColor: "#F3F4F6",
                        fontWeight: "bold",
                        color: "#111827",
                        textAlign: "left",
                        width: "200px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        padding: "8px",
                        verticalAlign: "top",
                      }}
                    >
                      {activity.activityName}
                    </td>
                    {studentsList.map(student => {
                      const record = activity.activityList.find(
                        r => r.studentId && r.studentId._id === student._id
                      );
                      const key = record?.activityRecordsId[0]?.key;
                      const bgColor = colorMap[key] || "transparent";

                      return (
                        <td
                          key={student._id}
                          style={{
                            backgroundColor: bgColor,
                            textAlign: "center",
                            fontWeight: "bold"
                          }}
                          title={key}
                        >
                          {key || "-"}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        </div>
      </>

    </>
  );
}
